import { Menu } from "antd";
import "./menu.scss"
export default Menu;
